<section class="page">
  <h3 translate>components.homePage.searchPropertiesByArea</h3>
  <div class="tab-group">
    <div
      class="tab"
      [ngClass]="{ selected: pisos }"
      (click)="cambiaTipo('pisos')"
      translate
    >
      components.homePage.flats
    </div>
    <div
      class="tab"
      [ngClass]="{ selected: edificios }"
      (click)="cambiaTipo('edificios')"
      translate
    >
      components.homePage.buildings
    </div>
    <div
      class="tab"
      [ngClass]="{ selected: casas }"
      (click)="cambiaTipo('casas')"
      translate
    >
      components.homePage.houses
    </div>
    <div
      class="tab"
      [ngClass]="{ selected: renta }"
      (click)="cambiaTipo('renta')"
      translate
    >
      components.homePage.oldRent
    </div>
  </div>
  <div class="tab-group">
    <div
      class="tab"
      [ngClass]="{ selected: provincia }"
      (click)="cambiaTipo('provincia')"
      translate
    >
      components.homePage.provinces
    </div>
    <div
      class="tab"
      [ngClass]="{ selected: localidades }"
      (click)="cambiaTipo('localidades')"
      translate
    >
      components.homePage.locations
    </div>
  </div>
  <section id="pisos" class="esconde">
    <div class="links">
      <div id="pisos_pagina_1" class="muestra">
        <div class="grid-container" [innerHTML]="templateHTMLPisos1"></div>
      </div>
      <div id="pisos_pagina_2" class="esconde">
        <div class="grid-container" [innerHTML]="templateHTMLPisos2"></div>
      </div>
      <div id="pisos_pagina_3" class="esconde">
        <div class="grid-container" [innerHTML]="templateHTMLPisos3"></div>
      </div>
      <div id="pisos_pagina_4" class="esconde">
        <div class="grid-container" [innerHTML]="templateHTMLPisos4"></div>
      </div>
      <div id="pisos_pagina_5" class="esconde">
        <div class="grid-container" [innerHTML]="templateHTMLPisos5"></div>
      </div>
    </div>
    <div class="contenido">
      <div class="paginas">
        <p
          (click)="onChangePaginaFlats('1')"
          [ngClass]="paginaFlats == 1 ? 'seleccionado' : ''"
        >
          1
        </p>
        <p
          (click)="onChangePaginaFlats('2')"
          [ngClass]="paginaFlats == 2 ? 'seleccionado' : ''"
        >
          2
        </p>
        <p
          (click)="onChangePaginaFlats('3')"
          [ngClass]="paginaFlats == 3 ? 'seleccionado' : ''"
        >
          3
        </p>
        <p
          (click)="onChangePaginaFlats('4')"
          [ngClass]="paginaFlats == 4 ? 'seleccionado' : ''"
        >
          4
        </p>
        <p
          (click)="onChangePaginaFlats('5')"
          [ngClass]="paginaFlats == 5 ? 'seleccionado' : ''"
        >
          5
        </p>
      </div>
    </div>
  </section>
  <section>
    <div class="links esconde" id="edificios">
      <div class="grid-container" [innerHTML]="templateHTMLEdificio"></div>
    </div>
    <div class="links muestra" id="provincias">
      <div class="grid-container" [innerHTML]="templateHTMLProvincias"></div>
    </div>
    <div class="links esconde" id="casas">
      <div class="grid-container" [innerHTML]="templateHTMLCasa"></div>
    </div>
    <div class="links esconde" id="localidades">
      <div id="lo_pagina_1" class="muestra">
        <div class="grid-container" [innerHTML]="templateHTMLLocations1"></div>
      </div>
      <div id="lo_pagina_2" class="esconde">
        <div class="grid-container" [innerHTML]="templateHTMLLocations2"></div>
      </div>
      <div id="lo_pagina_3" class="esconde">
        <div class="grid-container" [innerHTML]="templateHTMLLocations3"></div>
      </div>
    </div>
    <div *ngIf="localidades" class="contenido">
      <div class="paginas">
        <p
          (click)="onChangePaginaLoc('1')"
          [ngClass]="paginaLoc == 1 ? 'seleccionado' : ''"
        >
          1
        </p>
        <p
          (click)="onChangePaginaLoc('2')"
          [ngClass]="paginaLoc == 2 ? 'seleccionado' : ''"
        >
          2
        </p>
        <p
          (click)="onChangePaginaLoc('3')"
          [ngClass]="paginaLoc == 3 ? 'seleccionado' : ''"
        >
          3
        </p>
      </div>
    </div>
    <div class="links esconde" id="renta">
      <div class="grid-container" [innerHTML]="templateHTMLRentaAntigua"></div>
    </div>
  </section>
</section>
